import en from "./en";
import fa from "./fa";
const Vocabs = {
  en,
  fa,
};



const returnStr=(txt,language)=>{
  return (Vocabs[language?'fa':'en'][txt] || '')
} 


export default returnStr